module.exports = __webpack_public_path__ + "static/media/pan-pin.7cd8fdc4.png";